<template>
  <div class="c-filter">
    <div class="c-btn"></div>
    <div class="c-form">
      <el-form label-width="50px" inline class="elementui-common-form-styles" v-highlight @submit.native.prevent>
        <el-form-item label="游戏">
          <ThrottleSelector v-model="gameId" :list="gameData" style="width: 160px" placeholder="全部" filterable clearable />
        </el-form-item>
        <el-form-item label="创建人">
          <ThrottleSelector v-model="agentId" :list="userList" style="width: 160px" placeholder="全部" filterable clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="keyword" :placeholder="placeholder" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search" style="cursor: pointer"></i>
          </el-input>
        </el-form-item>

        <el-form-item class="bg-transparent">
          <slot></slot>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { initPageData, ALL_GAMES, SYS_USERS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([ALL_GAMES, SYS_USERS])

// eslint-disable-next-line
const props = defineProps({
  placeholder: String
})

// eslint-disable-next-line
const emit = defineEmits(['on-change', 'on-search'])
const gameData = computed(PAGE_REQUIRED_OPTS.ALL_GAMES)
const userList = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const keyword = ref('')
const gameId = ref('')
const agentId = ref('')

const sendEvent = () => {
  const params = {
    gameId: gameId.value === '' ? undefined : gameId.value,
    opId: agentId.value === '' ? undefined : agentId.value
  }
  emit('on-change', params)
}

const search = () => {
  const params = {
    gameId: gameId.value === -1 ? undefined : gameId.value,
    opId: agentId.value === '' ? undefined : agentId.value
  }
  Object.assign(params, { keyWord: keyword.value === '' ? undefined : keyword.value })
  emit('on-search', params)
}

watch(gameId, () => {
  sendEvent()
})

watch(agentId, () => {
  sendEvent()
})

onMounted(() => {
  sendEvent()
})
</script>
